import type { DatePickerProps } from "antd";
import bgPickerLocale from "antd/es/date-picker/locale/bg_BG";
import { useTranslation } from "react-i18next";
// Само регистрира българските имена на месеци/дни в dayjs — НЕ сменя
// глобалния език на dayjs (antd форматира календара с локала от `locale`).
import "dayjs/locale/bg";

/**
 * Локалът на календарите в модула: на български — „септември 2026",
 * „пн вт…", „Днес"; на английски — стандартният на antd. Глобалният antd
 * ConfigProvider задава само преводите на таблиците.
 */
export const useDatePickerLocale = (): DatePickerProps["locale"] => {
  const { i18n } = useTranslation();
  return (i18n.language ?? "bg").startsWith("en") ? undefined : bgPickerLocale;
};
